'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var DESIGN_WIDTH = 375;
var transformPx = function transformPx(target) {
    var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.innerWidth / DESIGN_WIDTH;

    target += '';
    if (target.includes('px')) {
        return target.replace('px', '') * scale + 'px';
    } else {
        return target * scale;
    }
};
exports.default = transformPx;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/lib/transformPx.js
// module id = 236
// module chunks = 0